module.exports = __webpack_public_path__ + "img/note.69bde0cb.svg";